const changeFontColor = () => {
  const getContrastYIQ = (rgbColor) => {
    const match = rgbColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) return 'dark';
    const yiq = (match[1] * 299 + match[2] * 587 + match[3] * 114) / 1000;
    return yiq >= 128 ? 'dark' : 'light';
  };
  const rootElem = document.documentElement;
  const subscribeBtn = document.querySelector('.gh-header .gh-accent-button');
  if (subscribeBtn) {
    const subscribeBtnColor = window.getComputedStyle(subscribeBtn).backgroundColor;
    const fontColor = getContrastYIQ(subscribeBtnColor);
    rootElem.classList.add(`gh-btns-font-color-${fontColor}`);
  }
};

export { changeFontColor };
